export interface IPhaseAliasDto {
  PhaseAliasId: Guid;
  Name: string;
  PhaseTypeIds: Array<number>;
}

export class PhaseAliasDto implements IPhaseAliasDto {
  PhaseAliasId = "";
  Name = "";
  PhaseTypeIds = [] as number[] ;
}
